import { confirm } from "@/lib/confirm"

export async function cancelGenerationJob(projectId: number, jobId: number, confirmMessage: string) {
  if (!(await confirm({ message: confirmMessage, tone: "danger" }))) return
  const csrf = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content ?? ""
  void fetch(`/projects/${projectId}/workspace/generation_jobs/${jobId}/cancel`, {
    method: "PATCH",
    headers: { "X-CSRF-Token": csrf, Accept: "application/json" },
  })
}
